/* Navaro's shipping threshold is denominated in the shop currency. */
(() => {
  function threshold(baseAmount, rate) {
    return Math.round(Number(baseAmount) * 100 * Number(rate));
  }

  function conversion(element) {
    const currency = element.dataset.currency;
    const baseCurrency = element.dataset.baseCurrency;
    const active = window.Shopify && window.Shopify.currency;
    const rate = currency === baseCurrency ? 1 : Number(active && active.rate);
    if (!currency || !Number.isFinite(rate) || rate <= 0 ||
        (currency !== baseCurrency && (!active || active.active !== currency))) return null;
    return { currency, rate };
  }

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  class NavaroShippingMoney extends HTMLElement {
    connectedCallback() {
      const context = conversion(this);
      if (!context) return;
      this.textContent = money(threshold(this.dataset.baseAmount, context.rate), context.currency);
    }
  }

  class NavaroShippingProgress extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.render());
    }

    render() {
      if (!this.isConnected) return;
      const context = conversion(this);
      const text = this.querySelector('.cart-progress__text');
      const bar = this.querySelector('.cart-progress__bar');
      const fill = this.querySelector('.cart-progress__bar__progress');
      if (!text || !bar || !fill) return;
      if (!context) {
        text.textContent = `Free shipping on US$${this.dataset.baseGoal}+ (local equivalent).`;
        bar.hidden = true;
        this.removeAttribute('data-pending');
        return;
      }
      const goal = threshold(this.dataset.baseGoal, context.rate);
      const subtotal = Number(this.dataset.subtotal);
      if (!(goal > 0) || !Number.isFinite(subtotal)) return;
      const remaining = Math.max(0, goal - subtotal);
      const template = this.querySelector(remaining === 0 ?
        'template[data-success-message]' : 'template[data-progress-message]');
      if (!template) return;
      const amount = money(remaining, context.currency);
      text.innerHTML = template.innerHTML.replace(/\[amount\]/g, `<span>${amount}</span>`);
      fill.style.width = `${Math.max(0, Math.min(100, subtotal / goal * 100))}%`;
      bar.hidden = false;
      this.dataset.goalMinor = String(goal);
      this.dataset.remainingMinor = String(remaining);
      this.dataset.resolvedCurrency = context.currency;
      this.removeAttribute('data-pending');
    }
  }

  if (!customElements.get('navaro-shipping-money')) {
    customElements.define('navaro-shipping-money', NavaroShippingMoney);
  }
  if (!customElements.get('navaro-shipping-progress')) {
    customElements.define('navaro-shipping-progress', NavaroShippingProgress);
  }
})();
